import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Span = styled.span(
  ({ theme, visibility, hidePhoneNumberOnMobile }) => css`
    display: inline-block;
    white-space: nowrap;

    @media (max-width: ${theme.breakpoints.sm}) {
      ${hidePhoneNumberOnMobile && `display: none;`}
    }

    ${visibility === 'mobile only' &&
    css`
      @media (min-width: ${theme.breakpoints.sm}) {
        display: none;
      }
    `}

    ${visibility === 'desktop only' &&
    css`
      @media (max-width: ${theme.breakpoints.sm}) {
        display: none;
      }
    `}
  `
)
